// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IModelResponse, IModel } from '@cian/http-api';
import type { IGetProjectsListV2ResponseSchema } from '../../entities/v2_entities/GetProjectsListV2ResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export interface IGetProjectsListRequest {
  /** Идентификатор региона **/
  regionId?: number;
  /** Цена от **/
  priceFrom?: number;
  /** Цена до **/
  priceTo?: number;
  /** Площадь от **/
  areaFrom?: number;
  /** Площадь до **/
  areaTo?: number;
  /** Этажность **/
  floors?: EFloors[];
  /** Материалы **/
  materials?: EMaterials[];
  /** Номер страницы **/
  page?: number;
  /** Количество элементов в списке для выдачи **/
  limit?: number;
  /** Поддомен (для определения локации) **/
  subdomain?: string;
}
export enum EFloors {
  /** Один **/
  'One' = 'one',
  /** Три и более **/
  'ThreeAndMore' = 'threeAndMore',
  /** Два **/
  'Two' = 'two',
}
export enum EMaterials {
  /** Блоки **/
  'Blocks' = 'blocks',
  /** Кирпич **/
  'Brick' = 'brick',
  /** Каркасные дома **/
  'FrameHouses' = 'frameHouses',
  /** Клееный брус **/
  'GluedLaminatedTimber' = 'gluedLaminatedTimber',
  /** Монолит **/
  'Monolith' = 'monolith',
  /** Другое **/
  'Other' = 'other',
  /** СИП технологии **/
  'Sip' = 'sip',
  /** Цельное дерево (бревно или брус) **/
  'SolidTree' = 'solidTree',
}

export type IGetProjectsListResponse = IGetProjectsListV2ResponseSchema;

export interface IGetProjectsListResponse200 extends IModelResponse<IGetProjectsListResponse> {
  statusCode: 200;
}

export type IGetProjectsListResponseError = IErrorResponseSchema;

export interface IGetProjectsListResponse400 extends IModelResponse<IGetProjectsListResponseError> {
  statusCode: 400;
}

export type TGetProjectsListResponse = IGetProjectsListResponse200 | IGetProjectsListResponse400;

export type TGetProjectsListModel = IModel<IGetProjectsListRequest, TGetProjectsListResponse>;

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetProjectsListResponse): TResponse200;
  400(response: IGetProjectsListResponseError): TResponse400;
}
